import { useState } from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';
import DateTimePicker from '~/view/components/Controls/Pickers/DateTimePicker/DateTimePicker';
import { messageCampaignStore } from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignEditScreen/store/messageCampaignStore';

const CampaignTimeLater = observer(() => {
  const [setting] = messageCampaignStore.form.settings.values();
  const [dateTime, setDateTime] = useState(setting.startTime);

  const changeDate = (date: Date) => {
    if (moment(date).isSame(messageCampaignStore.form.startAt)) return;

    setDateTime(date);

    messageCampaignStore.changeForm({
      startAt: date,
      endAt: date,
    });
  };

  return <DateTimePicker date={dateTime} onDateChange={changeDate} minDate={new Date()} position="bottom" />;
});

export default CampaignTimeLater;
